export default __webpack_public_path__ + "static/media/directory-2.2eb3ada4.jpeg";